import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import isLoggedIn from '../../../utils/index.js';

class SubscribeNewsletterBtn extends Component {
  constructor(props) {
    super(props);
  }


  handleClick = (e) => {
    e.preventDefault();
    //this.props.push('/story-archive');
  }

  handleSignUpClick = (e) => {
    e.preventDefault();
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
    this.props.openSignupFormRequest();
  }

  

  render() {
    
    const { user } = this.props.user;
    let joinSection = <div className="home-subscribeNewsletterBtnWrapper">
        <button onClick={this.handleSignUpClick.bind(this)}
          className="newsBtn">Subscribe to newsletter</button>
      </div>;


    if(isLoggedIn(user)) {
      joinSection = '';
    }
    return(
      <div>
        {joinSection}
      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    Link,
    push
  }
)(SubscribeNewsletterBtn);



// WEBPACK FOOTER //
// ./src/components/home/HomeNewsletter/SubscribeNewsletterBtn.jsx